import React, {useState} from "react";
import "../../../components/groupItemPresenter.scss";
import {useTranslation} from "react-i18next";
import {LengthMeasurementDrop} from "../../../models/editor";
import {useUserSettingsDataContext} from "../../../../../../../providers/UserSettingsProvider";
import {formatLength} from "../../../../../../../utils/TextUtils";
import SetNumberValueModal from "./SetNumberValueModal";
import {useHighlightSetter} from "../../../hooks/highlight";

interface DropItemProps {
	drop: LengthMeasurementDrop,
	onDelete: (id: string) => void,
	onChange: (id: string, value: number) => void,
	disabled?: boolean,
}

const DropItem: React.FC<DropItemProps> = ({drop, onDelete, onChange, disabled}) => {

	const {settings} = useUserSettingsDataContext();
	const [isOpen, setIsOpen] = useState(false);
	const highlightActions = useHighlightSetter(drop.id);

	const {t} = useTranslation();

	function handleSave(value: number) {
		onChange(drop.id, value);
		setIsOpen(false);
	}

	function handleDelete() {
		if (!disabled) {
			highlightActions.clearHighlight();
			onDelete(drop.id);
		}
	}

	const propsCls = [
		"group-item-presenter_props",
		!disabled && "is-clickable",
		disabled && "disabled"
	].filter(Boolean).join(" ");

	const actionsButtonCls = [
		"group-item-presenter_actions_button",
		disabled && "disabled"
	].filter(Boolean).join(" ");

	return (
		<>
			<SetNumberValueModal isOpen={isOpen}
								 initialValue={drop.value}
								 onSave={handleSave}
								 onClose={() => setIsOpen(false)}
								 title={t("editor.length.setDropValueModal.title")}
								 inputLabel={t("editor.length.setDropValueModal.inputLabel")}/>
			<div className={"group-item-presenter"}
				 onMouseEnter={highlightActions.setHighlight}
				 onMouseLeave={highlightActions.clearHighlight}>
				<div className={"group-item-presenter_label"}>{t("editor.length.dropItemName")}</div>
				<div className={propsCls}
					 onClick={() => !disabled && setIsOpen(true)}>
					{formatLength(drop.value, settings?.measurementSystem)}
				</div>
				<div className={"group-item-presenter_actions"}>
					<div className={actionsButtonCls} onClick={handleDelete}>
						&times;
					</div>
				</div>
			</div>
		</>
	);
};

export default DropItem
